"use strict";
/*
 * Created on 25. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var utils_1 = require("../../core/utils");

var RangeConverter_1 = require("../../general-settings/conversions/constraint/RangeConverter");

var OptimizationGoalsSettings_1 = require("../../general-settings/model/optimalization-goal/OptimizationGoalsSettings");

var ImpactRecord_1 = require("../model/ImpactRecord");

var ImpactRecordConverter_1 = require("./ImpactRecordConverter");
/**
 * Default implementation of {@link ImpactRecordConverter}.
 *
 * @author Radek Beran
 */


var ImpactRecordConverterImpl =
/*#__PURE__*/
function (_ImpactRecordConverte) {
  _inherits(ImpactRecordConverterImpl, _ImpactRecordConverte);

  function ImpactRecordConverterImpl(rangeConverter) {
    var _this;

    _classCallCheck(this, ImpactRecordConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ImpactRecordConverterImpl).call(this));
    _this.rangeConverter = rangeConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ImpactRecordConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new ImpactRecord_1.ImpactRecord(conversions.documentToClassId(source), conversions.toClassReferenceId(source.releaseId), // todo remove exclamation mark after data schema is provided
      conversions.toClassReferenceId(source.categoryId), // todo remove exclamation mark after data schema is provided
      conversions.toClassReferenceId(source.priceZoneId), conversions.toBigNumber(source.priceChange), conversions.toBigNumber(source.priceSticker), utils_1.Utils.isObject(source.marginConstraint) ? this.rangeConverter.toObject(source.marginConstraint, conversions) : null, conversions.asEnumOpt(source.optimizationGoal, OptimizationGoalsSettings_1.OptimizationGoal), !utils_1.Utils.isValueMissing(source.marginOld) ? conversions.toBigNumber(source.marginOld) : null, !utils_1.Utils.isValueMissing(source.marginOldPercent) ? conversions.toBigNumber(source.marginOldPercent) : null, !utils_1.Utils.isValueMissing(source.marginNew) ? conversions.toBigNumber(source.marginNew) : null, !utils_1.Utils.isValueMissing(source.marginNewPercent) ? conversions.toBigNumber(source.marginNewPercent) : null, !utils_1.Utils.isValueMissing(source.marginImpact) ? conversions.toBigNumber(source.marginImpact) : null, !utils_1.Utils.isValueMissing(source.marginImpactPercent) ? conversions.toBigNumber(source.marginImpactPercent) : null, !utils_1.Utils.isValueMissing(source.salesVolumeOld) ? conversions.toBigNumber(source.salesVolumeOld) : null, !utils_1.Utils.isValueMissing(source.salesVolumeNew) ? conversions.toBigNumber(source.salesVolumeNew) : null, !utils_1.Utils.isValueMissing(source.salesVolumeImpact) ? conversions.toBigNumber(source.salesVolumeImpact) : null, !utils_1.Utils.isValueMissing(source.salesVolumeImpactPercent) ? conversions.toBigNumber(source.salesVolumeImpactPercent) : null, !utils_1.Utils.isValueMissing(source.revenueOld) ? conversions.toBigNumber(source.revenueOld) : null, !utils_1.Utils.isValueMissing(source.revenueNew) ? conversions.toBigNumber(source.revenueNew) : null, !utils_1.Utils.isValueMissing(source.revenueImpact) ? conversions.toBigNumber(source.revenueImpact) : null, !utils_1.Utils.isValueMissing(source.revenueImpactPercent) ? conversions.toBigNumber(source.revenueImpactPercent) : null, !utils_1.Utils.isValueMissing(source.profitOld) ? conversions.toBigNumber(source.profitOld) : null, !utils_1.Utils.isValueMissing(source.profitOldPercent) ? conversions.toBigNumber(source.profitOldPercent) : null, !utils_1.Utils.isValueMissing(source.profitNew) ? conversions.toBigNumber(source.profitNew) : null, !utils_1.Utils.isValueMissing(source.profitNewPercent) ? conversions.toBigNumber(source.profitNewPercent) : null, !utils_1.Utils.isValueMissing(source.profitImpact) ? conversions.toBigNumber(source.profitImpact) : null, !utils_1.Utils.isValueMissing(source.profitImpactPercent) ? conversions.toBigNumber(source.profitImpactPercent) : null);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this2 = this;

      var document = {};
      Object.assign(document, conversions.classToDocumentId(source));
      Object.assign(document, {
        releaseId: conversions.toDocumentReferenceId(source.releaseId),
        categoryId: conversions.toDocumentReferenceId(source.categoryId),
        priceZoneId: conversions.toDocumentReferenceId(source.priceZoneId),
        priceChange: conversions.fromBigNumber(source.priceChange),
        priceSticker: conversions.fromBigNumber(source.priceSticker),
        marginConstraint: source.marginConstraint !== null ? conversions.asObject(source, 'marginConstraint', function (range) {
          return _this2.rangeConverter.toDocument(source.marginConstraint, conversions);
        }) : null,
        optimizationGoal: source.optimizationGoal !== null ? source.optimizationGoal.toString() : null,
        marginOld: source.marginOld !== null ? conversions.fromBigNumber(source.marginOld) : null,
        marginOldPercent: source.marginOldPercent !== null ? conversions.fromBigNumber(source.marginOldPercent) : null,
        marginNew: source.marginNew !== null ? conversions.fromBigNumber(source.marginNew) : null,
        marginNewPercent: source.marginNewPercent !== null ? conversions.fromBigNumber(source.marginNewPercent) : null,
        marginImpact: source.marginImpact !== null ? conversions.fromBigNumber(source.marginImpact) : null,
        marginImpactPercent: source.marginImpactPercent !== null ? conversions.fromBigNumber(source.marginImpactPercent) : null,
        salesVolumeOld: source.salesVolumeOld !== null ? conversions.fromBigNumber(source.salesVolumeOld) : null,
        salesVolumeNew: source.salesVolumeNew !== null ? conversions.fromBigNumber(source.salesVolumeNew) : null,
        salesVolumeImpact: source.salesVolumeImpact !== null ? conversions.fromBigNumber(source.salesVolumeImpact) : null,
        salesVolumeImpactPercent: source.salesVolumeImpactPercent !== null ? conversions.fromBigNumber(source.salesVolumeImpactPercent) : null,
        revenueOld: source.revenueOld !== null ? conversions.fromBigNumber(source.revenueOld) : null,
        revenueNew: source.revenueNew !== null ? conversions.fromBigNumber(source.revenueNew) : null,
        revenueImpact: source.revenueImpact !== null ? conversions.fromBigNumber(source.revenueImpact) : null,
        revenueImpactPercent: source.revenueImpactPercent !== null ? conversions.fromBigNumber(source.revenueImpactPercent) : null,
        profitOld: source.profitOld !== null ? conversions.fromBigNumber(source.profitOld) : null,
        profitOldPercent: source.profitOldPercent !== null ? conversions.fromBigNumber(source.profitOldPercent) : null,
        profitNew: source.profitNew !== null ? conversions.fromBigNumber(source.profitNew) : null,
        profitNewPercent: source.profitNewPercent !== null ? conversions.fromBigNumber(source.profitNewPercent) : null,
        profitImpact: source.profitImpact !== null ? conversions.fromBigNumber(source.profitImpact) : null,
        profitImpactPercent: source.profitImpactPercent !== null ? conversions.fromBigNumber(source.profitImpactPercent) : null
      });
      return document;
    }
  }]);

  return ImpactRecordConverterImpl;
}(ImpactRecordConverter_1.ImpactRecordConverter);

ImpactRecordConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [RangeConverter_1.RangeConverter])], ImpactRecordConverterImpl);
exports.ImpactRecordConverterImpl = ImpactRecordConverterImpl;